// src/axios.js
import axios from "axios";
import store from "../store";

/**
 * 开发：baseURL 为空 → `/api` 由 vue.config.js 的 devServer.proxy 转发。
 * 生产：由 VUE_APP_API_BASE 决定（见根目录 .env.production），例如 https://jidilvzhou.xlag.cn
 *   - 留空：同源 `/api`（需在站点 Nginx 把 /api、/uploads 反代到后端，避免 CORS）
 *   - 未配置 .env 时：也默认同源 `/api`（避免线上仍直连造成 CORS）
 */
function resolveApiOrigin() {
  if (process.env.NODE_ENV === "development") return "";
  const v = process.env.VUE_APP_API_BASE;
  if (!v) return "";
  return String(v).replace(/\/$/, "");
}

export const API_ORIGIN = resolveApiOrigin();

// 创建axios实例
const service = axios.create({
  baseURL: API_ORIGIN,
  timeout: 20000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，例如设置请求头
    if (store.state.token) {
      config.headers["X-Requested-With"] = "XMLHttpRequest";
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response.data;
  },
  (error) => {
    // 对响应错误做点什么
    return Promise.reject(error);
  },
);

export default service;
